import { useDispatch, useSelector } from "react-redux";
import {
  clearPromoDetail,
  orderItem,
  removeItemFromCart,
} from "../../actions/cartAction";
import { getPatientNotification } from "../../actions/dashboardAction";
import { getCreatePrescriptionPatients } from "../../actions/patientAction";
import { practitonerOrderPostAction } from "../../actions/prescriptionAction";
import OrderReviewCartItem from "../../components/OrderReviewCartItem";
import ProductReviewItem from "../../components/ProductReviewItem";
import { getUserDetail } from "../../utils/helper";
import history from "../../utils/history";
import Loader from "../../components/Loader";
const OrderReview = ({
  billing,
  shipping,
  payment,
  cartItems,
  productList,
  isShipping,
  backAction,
  cvvValue,
  promoCode,
  shippingPrice,
  isTaxable,
  shippingCarrier,
}) => {
  const dispatch = useDispatch();
  const role = useSelector((state) => state.role.role);
  const appLoading = useSelector((state) => state.alert.appLoading);
  const promoDetail = useSelector((state) => state.cart.promoDetail);
  const freeShippingSettings = useSelector(
    (state) => state.settings.freeShippingSettings
  );

  // const getShippingPrice = () => {
  //   let newShippingPrice = 0;
  //   if (freeShippingSettings.isFreeShippingByAmountAvailable) {
  //     if (
  //       getSubTotal() >=
  //       parseFloat(freeShippingSettings.minimumFreeShippingPrice)
  //     ) {
  //       newShippingPrice = 0;
  //     } else {
  //       newShippingPrice = isShipping ? shippingPrice : 0;
  //       if (promoDetail?.shipping_free) {
  //         newShippingPrice = 0;
  //       }
  //     }
  //   } else {
  //     newShippingPrice = isShipping ? shippingPrice : 0;
  //     if (promoDetail?.shipping_free) {
  //       newShippingPrice = 0;
  //     }
  //   }

  //   return newShippingPrice;
  // };
  const getShippingPrice = () => {
    if (freeShippingSettings.isFreeShippingByAmountAvailable) {
      const subtotal = getSubTotal();
      const minimumFreeShippingPrice = parseFloat(
        freeShippingSettings.minimumFreeShippingPrice
      );

      return subtotal >= minimumFreeShippingPrice
        ? 0
        : promoDetail?.shipping_free
          ? 0
          : isShipping
            ? shippingPrice
            : 0;
    } else {
      return promoDetail?.shipping_free ? 0 : isShipping ? shippingPrice : 0;
    }
  };

  const handlePurchase = () => {
    if (cartItems.length > 0 || productList.length > 0) {
      let prescriptionIds = [];
      cartItems.forEach((x) => {
        prescriptionIds.push({ id: parseInt(x.prescriptionId) });
      });
      const userDetail = getUserDetail();
      const data = {
        params: {
          addr_id_bill: billing.address_id,
          addr_id_ship: shipping.address_id,
          delivery_method: isShipping ? 0 : 1,
          token: userDetail?.token,
          customerId: userDetail?.customerId,
          methodId: payment.MethodID,
          customerNumber: payment.CustomerNumber,
          cardInstanceId: payment.InstanceID,
          firstname: billing.first_name,
          lastname: billing.last_name,
          amount: parseFloat(
            cartItems
              .map((x) => x.total)
              .reduce((sum, val) => sum + parseFloat(val), getShippingPrice())
              .toFixed(2)
          ),
          prescriptions: prescriptionIds,
          products: productList,
          email: billing.email,
          fax: "",
          phone: billing.phone,
          country: "USA",
          address1: billing.address_1,
          address2: "",
          city: billing.city,
          state: billing.state,
          zip: billing.zip,
          location_id: billing.locationId,
          company: "",
          order_description: `Prescription for ${userDetail?.firstName} ${userDetail?.lastName}`,
          ship_zip: shipping.zip,
          ship_state: shipping.state,
          ship_lastname: shipping.last_name,
          ship_firstname: shipping.first_name,
          ship_email: shipping.email,
          ship_country: "USA",
          ship_company: "",
          ship_city: shipping.city,
          ship_address2: shipping.address_2,
          ship_address1: shipping.address_1,
          promo_code: promoDetail ? promoCode : null,
          shippingCarrier: shippingCarrier?.value,
          ship_location_id: shipping.locationId,
          freeShippingApplied: getShippingPrice() == 0 ? true : false,
        },
      };
      console.log(data);
      if (role.val === 3) {
        dispatch(
          orderItem(data, () => {
            cartItems.forEach((item) => {
              dispatch(removeItemFromCart(item));
            });
            dispatch(getPatientNotification(role.val));
            dispatch(clearPromoDetail());
            history.push("/app");
          })
        );
      } else {
        dispatch(
          practitonerOrderPostAction(data, () => {
            cartItems.forEach((item) => {
              dispatch(removeItemFromCart(item));
            });
            dispatch(getPatientNotification(role.val));
            dispatch(getCreatePrescriptionPatients());
            dispatch(clearPromoDetail());
            history.push("/app");
          })
        );
      }
    }
  };

  const getSubTotal = () => {
    return (
      productList
        .map((x) => x.price / 100)
        .reduce((sum, val) => sum + parseFloat(val), 0) +
      cartItems
        .map((x) => x.total)
        .reduce((sum, val) => sum + parseFloat(val), 0)
    );
  };

  const getTaxableAmount = () => {
    debugger;
    return cartItems
      .map((x) => x.taxablePrice)
      .reduce((sum, val) => sum + parseFloat(val), 0);
  };

  const getDiscountPrice = () => {
    let subtotal = getSubTotal();
    let discountAmount = 0;
    if (promoDetail) {
      discountAmount = (subtotal * promoDetail?.percent_off) / 100;
      discountAmount =
        discountAmount < promoDetail?.max_amount_off / 100
          ? discountAmount
          : promoDetail?.max_amount_off / 100;
    }
    return discountAmount;
  };

  return (
    <div>
      {appLoading && (
        <Loader
          duration={28000 + Math.max((cartItems?.length || 0) - 1, 0) * 5000}
        />
      )}
      <div className="row mt-2">
        {isShipping ? (
          <div className="col-md-4">
            <h5 className="profile-title">Ship To:</h5>
            <p className="title-text">
              {shipping.first_name} {shipping.last_name}
            </p>
            <p className="desc-text">{shipping.address_1}</p>
            {shipping?.address_2 && (
              <p className="desc-text">Apt {shipping.address_2}</p>
            )}
            <p className="desc-text">
              {shipping.city}, {shipping.state} {shipping.zip}
            </p>
            <p className="desc-text">Email: {shipping.email}</p>
          </div>
        ) : (
          <div className="col-md-4">
            <h5 className="profile-title">Pickup At:</h5>
            <p className="title-text">Sun Ten Laboratories</p>
            <p className="desc-text">9250 Jeronimo Road</p>
            <p className="desc-text">Irvine, CA 92618</p>
            <p className="desc-text">Phone: (800) 333-4372</p>
            <p className="desc-text">Email: order@sunten.com</p>
          </div>
        )}

        <div className="col-md-4">
          <h5 className="profile-title">Billed To:</h5>

          <p className="title-text">
            {billing.first_name} {billing.last_name}
          </p>
          <p className="desc-text">{billing.address_1}</p>
          {billing?.address_2 && (
            <p className="desc-text">Apt {billing.address_2}</p>
          )}
          <p className="desc-text">
            {billing.city}, {billing.state} {billing.zip}
          </p>
          <p className="desc-text">Email: {billing.email}</p>
        </div>
        <div className="col-md-4">
          <h5 className="profile-title">Payment Method:</h5>
          <p className="title-text">{payment?.AccountHolderName}</p>
          {payment?.MethodName && (
            <p className="desc-text">Method Name: {payment?.MethodName}</p>
          )}
          <p className="desc-text">Card Number: {payment?.CardNumber}</p>
          <p className="desc-text">Exp. Date: {payment?.CardExpiration}</p>
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-md-12">
          <h5 className="profile-title">Shipping Service</h5>

          <div>{shippingCarrier && shippingCarrier.label}</div>
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-md-12">
          <h5 className="profile-title">Your Cart</h5>
          {cartItems.length > 0 && (
            <>
              <table className="table table_3 shopping_table">
                <thead>
                  <tr>
                    <th
                      className="width-100"
                      style={{ textAligh: "center", width: "75px" }}
                    >
                      DELETE
                    </th>
                    <th className="width-100"></th>
                    <th style={{ textAligh: "left", width: "600px" }}>ITEM</th>
                    <th
                      className="text-right"
                      style={{ textAligh: "right", width: "150px" }}
                    >
                      WEIGHT
                    </th>
                    <th
                      className="text-right"
                      style={{ textAligh: "right", width: "150px" }}
                    >
                      PRICE
                    </th>
                    <th style={{ width: "50%" }}></th>
                  </tr>
                </thead>
                <tbody>
                  {cartItems.map((item) => {
                    return (
                      <>
                        <OrderReviewCartItem item={item} shipping={shipping} />
                      </>
                    );
                  })}
                </tbody>
              </table>
            </>
          )}
          {productList.length > 0 && (
            <>
              <table className="table table_3 shopping_table">
                <thead>
                  <tr>
                    <th
                      className="width-100"
                      style={{ textAligh: "center", width: "75px" }}
                    >
                      DELETE
                    </th>
                    <th className="width-100"></th>
                    <th style={{ textAligh: "left", width: "450px" }}>ITEM</th>

                    <th
                      className="text-right"
                      style={{ textAligh: "right", width: "150px" }}
                    >
                      QUANTITY
                    </th>
                    <th
                      className="text-right"
                      style={{ textAligh: "right", width: "150px" }}
                    >
                      WEIGHT
                    </th>
                    <th
                      className="text-right"
                      style={{ textAligh: "right", width: "150px" }}
                    >
                      PRICE
                    </th>
                    <th style={{ width: "50%" }}></th>
                  </tr>
                </thead>
                <tbody>
                  {productList.map((item) => {
                    return (
                      <>
                        <ProductReviewItem item={item} />
                      </>
                    );
                  })}
                </tbody>
                <tbody></tbody>
              </table>
            </>
          )}

          <table className="table table_3 shopping_table">
            <thead>
              <tr>
                <th
                  className="width-100"
                  style={{ textAligh: "center", width: "75px" }}
                ></th>
                <th className="width-100"></th>
                <th style={{ textAligh: "left", width: "600px" }}></th>
                <th
                  className="text-right"
                  style={{ textAligh: "right", width: "150px" }}
                ></th>
                <th
                  className="text-right"
                  style={{ textAligh: "right", width: "150px" }}
                ></th>
                <th style={{ width: "50%" }}></th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ border: "none" }}></tr>
              <tr className="alt top-seperate">
                <td></td>
                <td></td>
                <td></td>
                <td>
                  <div className="text-right">Subtotal:</div>
                </td>
                <td style={{ textAlign: "right" }}>
                  {getSubTotal().toLocaleString("en-US", {
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                    style: "currency",
                    currency: "USD",
                  })}
                </td>
              </tr>
              <tr className="alt">
                <td></td>
                <td></td>
                <td></td>
                <td>
                  <div className="text-right">Shipping: </div>
                </td>

                {promoDetail?.shipping_free ? (
                  <>
                    <td style={{ textAlign: "right" }}>Free</td>
                  </>
                ) : (
                  <td style={{ textAlign: "right" }}>
                    {isShipping
                      ? getShippingPrice().toLocaleString("en-US", {
                        maximumFractionDigits: 2,
                        minimumFractionDigits: 2,
                        style: "currency",
                        currency: "USD",
                      })
                      : "0.00"}
                  </td>
                )}
              </tr>
              {isTaxable && (
                <tr className="alt">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>
                    <div className="text-right">Tax:</div>
                  </td>
                  <td style={{ textAlign: "right" }}>
                    {(
                      ((getTaxableAmount() - getDiscountPrice()) * 7.75) /
                      100
                    ).toLocaleString("en-US", {
                      maximumFractionDigits: 2,
                      minimumFractionDigits: 2,
                      style: "currency",
                      currency: "USD",
                    })}
                  </td>
                </tr>
              )}
              {promoDetail && (
                <tr className="alt">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>
                    <div className="text-right">Promo Discount:</div>
                  </td>
                  <td style={{ textAlign: "right" }}>
                    (
                    {getDiscountPrice().toLocaleString("en-US", {
                      maximumFractionDigits: 2,
                      minimumFractionDigits: 2,
                      style: "currency",
                      currency: "USD",
                    })}
                    )
                  </td>
                </tr>
              )}
              <tr>
                <td style={{ border: "none" }}></td>
                <td style={{ border: "none" }}></td>
                <td style={{ border: "none" }}></td>
                <td
                  colSpan={2}
                  style={{
                    borderTop: "none",
                    borderBottom: "0.5px solid silver",
                  }}
                ></td>
              </tr>
              <tr className="alt">
                <td></td>
                <td></td>
                <td></td>
                <td>
                  <div className="text-right">Total:</div>
                </td>
                <td style={{ textAlign: "right" }}>
                  <strong>
                    {(
                      getSubTotal() +
                      getShippingPrice() -
                      getDiscountPrice() +
                      (isTaxable
                        ? ((getTaxableAmount() - getDiscountPrice()) * 7.75) /
                        100
                        : 0)
                    ).toLocaleString("en-US", {
                      maximumFractionDigits: 2,
                      minimumFractionDigits: 2,
                      style: "currency",
                      currency: "USD",
                    })}
                  </strong>
                </td>
              </tr>
            </tbody>
            <tbody></tbody>
          </table>

          <div className="row">
            <div className="col-md-12 mb-4 d-flex justify-content-between">
              <button className="btn-orange" onClick={() => backAction(false)}>
                back
              </button>
              <button
                disabled={appLoading}
                className="btn-orange"
                onClick={handlePurchase}
              >
                purchase
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default OrderReview;
